"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;
exports.hasOwn = hasOwn;
exports.toObject = toObject;
exports.getPropByPath = getPropByPath;
exports.camelcaseToHyphen = camelcaseToHyphen;
exports.extend = extend;
exports.cumulativeOffset = cumulativeOffset;
exports.oneOf = oneOf;
exports.findComponentUpward = findComponentUpward;
exports.each = each;
exports.caret = caret;
exports.ipRangeCheck = ipRangeCheck;
exports.isEmptyObj = isEmptyObj;
exports.isObject = exports.toUpperCaseFirst = exports.toCamelCase = exports.off = exports.on = exports.valueEquals = exports.generateId = exports.getValueByPath = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.last-index-of.js");

require("core-js/modules/es.parse-int.js");

var _lodash = _interopRequireDefault(require("lodash"));

var _vue = _interopRequireDefault(require("vue"));

var isServer = _vue["default"].prototype.$isServer;
var hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {}

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}

function _extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }

  return to;
}

function toObject(arr) {
  var res = {};

  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      _extend(res, arr[i]);
    }
  }

  return res;
}

var getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;

  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }

    current = current[path];
  }

  return result;
};

exports.getValueByPath = getValueByPath;

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');
  var keyArr = path.split('.');
  var i = 0;

  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];

    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }

      break;
    }
  }

  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
}

var generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

exports.generateId = generateId;

var valueEquals = function valueEquals(a, b) {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;

  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }

  return true;
};

exports.valueEquals = valueEquals;

function camelcaseToHyphen(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

exports.on = on;

var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();
/**
 * 转换为大小驼峰命名
 * abc-efg => abcEfg
 */


exports.off = off;

var toCamelCase = function toCamelCase(str) {
  return str.indexOf('-') !== -1 ? str.replace(/-([a-zA-Z])/g, function ($0, $1) {
    return $1.toUpperCase();
  }) : str;
};
/**
 * 首字母大写, 其他不变
 */


exports.toCamelCase = toCamelCase;

var toUpperCaseFirst = function toUpperCaseFirst(str) {
  return str[0].toUpperCase() + str.substr(1);
};
/**
 * 是否对象
 */


exports.toUpperCaseFirst = toUpperCaseFirst;

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

exports.isObject = isObject;

function extend() {
  var options;
  var name;
  var src;
  var copy;
  var copyIsArray;
  var clone;
  var target = arguments[0] || {};
  var i = 1;
  var length = arguments.length;
  var deep = false; // Handle a deep copy situation

  if (typeof target === 'boolean') {
    deep = target; // Skip the boolean and the target

    target = arguments[i] || {};
    i++;
  }

  if ((0, _typeof2["default"])(target) !== 'object' && !_lodash["default"].isFunction(target)) {
    target = {};
  }

  if (i === length) {
    target = this;
    i--;
  }

  for (; i < length; i++) {
    // Only deal with non-null/undefined values
    if ((options = arguments[i]) != null) {
      // Extend the base object
      for (name in options) {
        src = target[name];
        copy = options[name]; // Prevent never-ending loop

        if (target === copy) {
          continue;
        } // Recurse if we're merging plain objects or arrays


        if (deep && copy && (_lodash["default"].isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && Array.isArray(src) ? src : [];
          } else {
            clone = src && _lodash["default"].isPlainObject(src) ? src : {};
          } // Never move original objects, clone them


          target[name] = extend(deep, clone, copy); // Don't bring in undefined values
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }

  return target;
}
/**
 * 元素到container的top、left
 * 默认container是body
 */


function cumulativeOffset(element, containerClass) {
  var top = 0;
  var left = 0;

  var cont = function cont(el, containerClass) {
    return containerClass ? el.className.indexOf(containerClass) === -1 : el.tagName !== 'BODY';
  };

  do {
    top += element.offsetTop + element.clientTop;
    left += element.offsetLeft + element.clientLeft;
    element = element.offsetParent;
  } while (element && cont(element, containerClass));

  return {
    top: top,
    left: left
  };
}

function oneOf(value, validList) {
  for (var i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }

  return false;
} // Find components upward


function findComponentUpward(content, componentName, componentNames) {
  if (typeof componentName === 'string') {
    componentNames = [componentName];
  } else {
    componentNames = componentName;
  }

  var parent = content.$parent;
  var name = parent.$options.name;

  while (parent && (!name || componentNames.indexOf(name) < 0)) {
    parent = parent.$parent;
    if (parent) name = parent.$options.name;
  }

  return parent;
}

function each(dom, callback, args) {
  callback.call(dom, 0, dom);
  return dom;
}

function caret(s, e, dom) {
  var setPosition = function setPosition(el, start, end) {
    if (el.setSelectionRange) {
      el.focus();
      el.setSelectionRange(start, end);
    } else if (el.createTextRange) {
      var range = el.createTextRange();
      range.collapse(true);
      range.moveEnd('character', end);
      range.moveStart('character', start);
      range.select();
    }
  };

  if (s != null && e != null) {
    // setting range
    return each(function () {
      setPosition(this, s, e);
    });
  } else if (s != null) {
    // setting position
    return each(dom, function () {
      setPosition(this, s, s);
    });
  } else {
    // getting
    var el = dom;

    if (el.createTextRange) {
      var r = document.selection.createRange().duplicate();
      var end = el.value.lastIndexOf(r.text) + r.text.length;
      r.moveEnd('character', el.value.length);
      var start = r.text === '' ? el.value.length : el.value.lastIndexOf(r.text);
      return [start, end];
    } else {
      return [el.selectionStart, el.selectionEnd];
    }
  }
}

function ipRangeCheck(startIp, endIp, inputIp) {
  console.log(startIp, endIp, inputIp);

  if (!startIp || !endIp || !inputIp) {
    return false;
  }

  var startIps = startIp.split('.');
  var endIps = endIp.split('.');
  var inputIps = inputIp.split('.');

  if (startIps.length !== 4 || endIps.length !== 4 || inputIps.length !== 4) {
    return false;
  }

  var i = 0;
  var startIpValue = 0;
  var endIpValue = 0;
  var inputIpValue = 0;

  for (i = 0; i < 4; i = i + 1) {
    startIpValue = startIpValue * 256 + parseInt(startIps[i], 10);
    endIpValue = endIpValue * 256 + parseInt(endIps[i], 10);
    inputIpValue = inputIpValue * 256 + parseInt(inputIps[i], 10);
  }

  return inputIpValue >= startIpValue && inputIpValue <= endIpValue;
}
/**
 * 判断字符串是否为空或null undefine
 */


function isEmptyObj(str) {
  return str === null || str === undefined || str === '' || // str === 'null' ||
  // str === 'undefined' ||
  _lodash["default"].isArray(str) && !str.length;
}